<template>
<div class="contacts">
    <h1>
   Монумент Киржач
</h1>

<v-container grid-list-md text-lg-center>
 <v-layout>
 <v-flex lg6>
 <v-card >
       

        <v-card-title primary-title>
          <div class="info">
            <h2 > Изготовление памятников в Киржаче</h2>
  

    <strong> Мы предлагаем весь спектр услуг:</strong>
<p>Продажа, установка и изготовление памятников.
Вспомогательной атрибутики:
Оград, мемориальных плит, цветников, цоколей и т.д.</p>
<p>На установку памятников и укладку плитки даем гарантию 3 года </p>
 <p>Вы можете заказать памятник по типовому или индивидуальному проекту.</p>
 

 <p> <strong>Контактные телефоны:
     +7-905-145-28-73</strong></p>
    <h2> Режим работы </h2>
     <p><strong> Будни 9 :00 - 17: 00 </strong></p>
      <p><strong> Суббота 9 :00 - 14: 00 </strong></p>
       <p><strong> Воскресенье: 9 :00 - 14: 00  </strong></p>
</div>
        </v-card-title>

    
      </v-card>
 </v-flex>


 <v-flex lg6 class="image">
      <v-card>
        <v-img
          src="/assets/img_contacts/1.jpg"
          aspect-ratio="1.75"
        ></v-img>

      </v-card>
    </v-flex>
 </v-layout>
</v-container>







<v-container grid-list-md text-lg-center>
   

<div class="adress">
    <h4>Мы находимся по адрессу:</h4>
  <h4>  Владимирская область г.Киржач ул.Большая Московская дом 4А</h4>
 
</div>
<div class="map">
   <v-flex lg12 > 

    <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A6997626d04fb6aa92938a7831f136d1b61ecfa3810160fed7b6aec9a36d1652a&amp;source=constructor" width="100%" height="500px" frameborder="1px" ></iframe>
    

    </v-flex>
    </div>
       </v-container>



  <v-footer class="pa-3">
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>

</div>




</template>

<script>



export default {
    name: "contacts"
}
  
</script>

<style scoped>
.contacts{
    margin-top: 100px;
}
.info{
    margin-bottom: 6px;
     line-height: 2;
}
.map{
    margin-top: 30px;
}
iframe{
   margin-bottom: -25px;
}
.adress{
    margin-top: 20px;
    margin-bottom: 20px
}

</style>
